import { Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PageWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: theme.spacing(15),
  background: theme.palette.background.default,

  [theme.breakpoints.down('md')]: {
    position: 'static',
    paddingTop: theme.spacing(8),
    paddingBottom: 0,
  },
}));

export const FormContainer = styled(Box)(({ theme }) => ({
  boxSizing: 'content-box',
  maxWidth: theme.spacing(117),
  padding: `${theme.spacing(4, 3)}`,

  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(8),
  },
}));

export const TitleBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(7),
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  fontSize: 56,
  fontWeight: 'bold',
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  fontWeight: 'normal',
  '& span': { fontWeight: '600' },

  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(2),
  },
}));

export const RegistrationSubtitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  fontSize: 20,
  lineHeight: 1.2,
  fontWeight: '600',
}));

export const ContentBox = styled(Paper)(({ theme }) => ({
  boxSizing: 'border-box',
  maxWidth: theme.spacing(117),
  padding: 0,
  paddingRight: `${theme.spacing(3)}`,
  display: 'flex',
  gap: theme.spacing(4),
  justifyContent: 'space-between',
  alignItems: 'stretch',

  [theme.breakpoints.down('md')]: {
    width: '100%',
    flexDirection: 'column',
    gap: 0,
    marginBottom: theme.spacing(8),
    padding: `${theme.spacing(2)}`,
  },
}));

export const RegistrationBox = styled(Paper)(({ theme }) => ({
  flexShrink: 0,
  width: theme.spacing(57),
  padding: `${theme.spacing(4, 3, 8, 3)}`,
  display: 'flex',
  flexDirection: 'column',

  [theme.breakpoints.down('md')]: {
    width: 'auto',
    paddingBottom: theme.spacing(8),
  },
}));

export const LoginBox = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  width: theme.spacing(47),
  padding: `${theme.spacing(4, 0)}`,
  boxSizing: 'border-box',

  [theme.breakpoints.down('md')]: {
    width: '100%',
    padding: theme.spacing(4),
    paddingTop: theme.spacing(5),
  },
}));

export const FooterWrapper = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  width: '100%',
  boxSizing: 'border-box',
  padding: `${theme.spacing(3)} ${theme.spacing(3)} ${theme.spacing(4)} ${theme.spacing(3)}`,
  backgroundColor: theme.palette.secondary.main,

  [theme.breakpoints.down('md')]: {
    position: 'static',
  },
}));

export const FooterContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 5,
  maxWidth: theme.spacing(117),
  margin: '0 auto',

  [theme.breakpoints.down('md')]: {
    maxWidth: 'fit-content',
  },
}));
